"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardCollectionParams = void 0;
exports.standardCollectionParams = {
    limit: 'Int',
    offset: 'Int',
    sortBy: 'String',
    sortByDesc: 'Boolean',
    keyword: '[String]',
    id: '[String]',
    createdDate: '[ISODate]',
    updatedDate: '[ISODate]',
    showArchived: 'Boolean',
    showMineOnly: '[String]',
    enabled: '[String]',
};
exports.default = exports.standardCollectionParams;
